import Vue from 'vue';
import Router from 'vue-router';
import Top from './pages/Top'
import Plan from './pages/Plan'
import NewPlan from './pages/NewPlan'
import EditPlan from './pages/EditPlan'
import Complete from './pages/Complete'
import Map from './pages/Map'
import Faq from './pages/Faq'
import Registered from './pages/Registered'

Vue.use(Router);

export default new Router({
  base: '/hawaii/',
  routes: [
    {
      path: '/',
      component: Top,
      name: 'root'
    },
    {
      path: '/:lang',
      component: Top,
      name: 'top'
    },
    {
      path: '/plan/:id',
      component: Plan,
      name: 'plan'
    },
    {
      path: '/plans',
      component: Top,
      name: 'plans'
    },
    {
      path: '/plans/new',
      component: NewPlan,
      name: 'newPlan',
      props: (route) => ({
        courseId: parseInt(route.params.courseId),
        poiId: parseInt(route.params.poiId)
      })
    },
    {
      path: '/plan/edit/:id',
      component: EditPlan,
      name: 'editPlan'
    },
    {
      path: '/complete/:planId',
      component: Complete,
      name: 'complete'
    },
    {
      path: '/:lang/map/tag/:tagId',
      component: Map,
      name: 'mapTag'
    },
    {
      path: '/:lang/map/:poiId?',
      component: Map,
      name: 'map'
    },
    {
      path: '/faq',
      component: Faq,
      name: 'faq'
    },
    {
      path: '/registered',
      component: Registered,
      name: 'registered'
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
});
